import React, { PureComponent } from 'react';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';
import PropTypes from 'prop-types';
import { messages } from 'features/Search/SearchBox/SearchBox.messages';
import css from './ViewToggler.scss';

export class ViewToggler extends PureComponent {
  render() {
    const { isMapView, onToggleMapView } = this.props;

    return (
      <div className={css.container} onClick={onToggleMapView}>
        <div className={css.viewToggler}>
          <span className={css.label}>
            <LocalizableMessage message={isMapView ? messages.listViewTogglerLabel : messages.mapViewTogglerLabel} />
          </span>
        </div>
      </div>
    );
  }
}

ViewToggler.propTypes = {
  isMapView: PropTypes.bool,
  onToggleMapView: PropTypes.func.isRequired,
};
